var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useState, useEffect, useRef, useCallback, } from "react";
import ReactEChartsCore from "echarts-for-react/lib/core";
import * as echarts from "echarts/core";
import { PieChart, BarChart, HeatmapChart, LineChart, MapChart, } from "echarts/charts";
import { GeoComponent, TitleComponent, TooltipComponent, LegendComponent, GridComponent, VisualMapComponent, } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { formatNumericValue, formatPercentValue, getChartDataset, isMultiSeriesChart, parseNumericValue, resolveLabelAndValueKeys, resolveMultiSeriesKeys, } from "../../utils/chartData";
import { normalizeChartDisplayData } from "../../utils/displayText";
import { getChartColor, DEAMS_PRIMARY_X_COLUMN, DEAMS_PRIMARY_VALUE_COLUMN, DEAMS_INITIAL_VISIBLE_CARDS, MONTH_LABELS_SHORT, } from "./utils/chartConstants";
import { buildMultiSeriesOption, buildHeatmapOption, buildMunicipiosMapOption, buildPieOption, buildSimpleLineOption, buildSimpleBarOption, } from "./adapters";
import { MobileLegendList, PieLegendList, DeamsLegendCards, } from "./components";
import TableRenderer from "./components/TableRenderer";
var PIAUI_MUNICIPIOS_MAP_KEY = "piaui-municipios";
var MUNICIPIOS_GEOJSON_ASSET = "geojs-22-mun.json";
var WEBGATE_BASE_PATH = "observatorio-direitos-humanos";
var municipiosGeoJsonCache = null;
var municipiosGeoJsonPromise = null;
var buildMapAssetUrl = function (baseUrl) {
    var base = String(baseUrl !== null && baseUrl !== void 0 ? baseUrl : "")
        .trim()
        .replace(/\/+$/, "");
    return base
        ? "".concat(base, "/").concat(MUNICIPIOS_GEOJSON_ASSET)
        : "/".concat(MUNICIPIOS_GEOJSON_ASSET);
};
var getCurrentBundleBaseUrls = function () {
    return Array.from(document.scripts)
        .map(function (script) { return script.src; })
        .filter(function (src) { return src.includes("/static/js/"); })
        .map(function (src) {
        try {
            var url = new URL(src, window.location.href);
            var staticIndex = url.pathname.indexOf("/static/");
            var basePath = staticIndex >= 0
                ? url.pathname.slice(0, staticIndex)
                : url.pathname.replace(/\/[^/]*$/, "");
            return "".concat(url.origin).concat(basePath);
        }
        catch (_a) {
            return "";
        }
    })
        .filter(Boolean);
};
var buildMunicipiosMapAssetCandidates = function () {
    var candidates = __spreadArray(__spreadArray([], getCurrentBundleBaseUrls(), true), [
        process.env.PUBLIC_URL,
        window.__APP_BASE__,
        "/app/".concat(WEBGATE_BASE_PATH),
        "/".concat(WEBGATE_BASE_PATH),
        "",
    ], false).map(buildMapAssetUrl);
    return Array.from(new Set(candidates));
};
var loadMunicipiosGeoJson = function () { return __awaiter(void 0, void 0, Promise, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (municipiosGeoJsonCache)
                    return [2 /*return*/, municipiosGeoJsonCache];
                if (municipiosGeoJsonPromise)
                    return [2 /*return*/, municipiosGeoJsonPromise];
                municipiosGeoJsonPromise = (function () { return __awaiter(void 0, void 0, void 0, function () {
                    var errors, _i, _a, assetUrl, response, contentType, text, trimmedText, geoJson, message, error_2, message;
                    var _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                errors = [];
                                _i = 0, _a = buildMunicipiosMapAssetCandidates();
                                _c.label = 1;
                            case 1:
                                if (!(_i < _a.length)) return [3 /*break*/, 7];
                                assetUrl = _a[_i];
                                _c.label = 2;
                            case 2:
                                _c.trys.push([2, 5, , 6]);
                                return [4 /*yield*/, fetch(assetUrl, {
                                        cache: "force-cache",
                                        headers: {
                                            Accept: "application/geo+json, application/json, text/plain, */*",
                                        },
                                    })];
                            case 3:
                                response = _c.sent();
                                contentType = (_b = response.headers.get("content-type")) !== null && _b !== void 0 ? _b : "";
                                return [4 /*yield*/, response.text()];
                            case 4:
                                text = _c.sent();
                                trimmedText = text.trimStart();
                                if (!response.ok) {
                                    throw new Error("status=".concat(response.status, "; content-type=").concat(contentType));
                                }
                                if (!trimmedText) {
                                    throw new Error("resposta vazia; content-type=".concat(contentType));
                                }
                                if (trimmedText.startsWith("<")) {
                                    throw new Error("HTML recebido; content-type=".concat(contentType));
                                }
                                geoJson = void 0;
                                try {
                                    geoJson = JSON.parse(text);
                                }
                                catch (error) {
                                    message = error instanceof Error ? error.message : String(error);
                                    throw new Error("JSON inv\u00E1lido; content-type=".concat(contentType, "; ").concat(message));
                                }
                                if (geoJson.type !== "FeatureCollection" ||
                                    !Array.isArray(geoJson.features)) {
                                    throw new Error("GeoJSON inv\u00E1lido; content-type=".concat(contentType));
                                }
                                municipiosGeoJsonCache = geoJson;
                                return [2 /*return*/, geoJson];
                            case 5:
                                error_2 = _c.sent();
                                message = error_2 instanceof Error ? error_2.message : String(error_2);
                                errors.push("".concat(assetUrl, " (").concat(message, ")"));
                                return [3 /*break*/, 6];
                            case 6:
                                _i++;
                                return [3 /*break*/, 1];
                            case 7: throw new Error("Falha ao carregar GeoJSON de munic\u00EDpios. Tentativas: ".concat(errors.join(" | ")));
                        }
                    });
                }); })();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, municipiosGeoJsonPromise];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_1 = _a.sent();
                municipiosGeoJsonPromise = null;
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
echarts.use([
    PieChart,
    BarChart,
    HeatmapChart,
    LineChart,
    MapChart,
    GeoComponent,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    VisualMapComponent,
    CanvasRenderer,
]);
var DEAMS_DELEGACIA_YAXIS_STEP = 30;
var DEAMS_DELEGACIA_YAXIS_MAX = 150;
var DEAMS_TERRITORIO_YAXIS_STEP = 50;
var isDeamsMonthlySeries = function (data) {
    var _a, _b, _c, _d;
    var columns = (_a = data.columns) !== null && _a !== void 0 ? _a : [];
    var firstColumn = (_b = columns[0]) === null || _b === void 0 ? void 0 : _b.name;
    var secondColumn = (_c = columns[1]) === null || _c === void 0 ? void 0 : _c.name;
    var thirdColumn = (_d = columns[2]) === null || _d === void 0 ? void 0 : _d.name;
    return (firstColumn === DEAMS_PRIMARY_X_COLUMN &&
        thirdColumn === DEAMS_PRIMARY_VALUE_COLUMN &&
        (secondColumn === "serie" ||
            secondColumn === "delegacia" ||
            secondColumn === "territorio"));
};
var formatPeriodoLabel = function (periodo) {
    var _a;
    var match = periodo.match(/^(\d{4})-(\d{2})$/);
    if (!match)
        return periodo;
    var monthIndex = Number(match[2]) - 1;
    var yearShort = match[1].slice(2);
    return "".concat((_a = MONTH_LABELS_SHORT[monthIndex]) !== null && _a !== void 0 ? _a : match[2], "/").concat(yearShort);
};
var formatPeriodoTooltipLabel = function (periodo) {
    var _a;
    var match = periodo.match(/^(\d{4})-(\d{2})$/);
    if (!match)
        return periodo;
    var monthIndex = Number(match[2]) - 1;
    return "".concat((_a = MONTH_LABELS_SHORT[monthIndex]) !== null && _a !== void 0 ? _a : match[2], "/").concat(match[1]);
};
var buildDeamsYAxisTicks = function (dataset) {
    var isDelegaciaMode = dataset.some(function (item) { return Boolean(item.delegacia); });
    var yAxisStep = isDelegaciaMode
        ? DEAMS_DELEGACIA_YAXIS_STEP
        : DEAMS_TERRITORIO_YAXIS_STEP;
    var maxValue = dataset.reduce(function (currentMax, item) {
        return Math.max(currentMax, parseNumericValue(item.quantidade));
    }, 0);
    var yAxisMax = isDelegaciaMode
        ? DEAMS_DELEGACIA_YAXIS_MAX
        : Math.max(DEAMS_DELEGACIA_YAXIS_MAX, Math.ceil(maxValue / yAxisStep) * yAxisStep);
    var tickCount = Math.floor(yAxisMax / yAxisStep) + 1;
    var ticks = Array.from({ length: tickCount }, function (_, i) { return i * yAxisStep; });
    return { yAxisMax: yAxisMax, yAxisStep: yAxisStep, ticks: ticks };
};
var ChartRenderer = function (_a) {
    var data = _a.data, title = _a.title, bare = _a.bare, chartType = _a.chartType, mobileLegendList = _a.mobileLegendList, chartGroup = _a.chartGroup, loading = _a.loading;
    var displayData = useMemo(function () { return normalizeChartDisplayData(data); }, [data]);
    var effectiveType = chartType !== null && chartType !== void 0 ? chartType : displayData.chart;
    var baseType = effectiveType.startsWith("bar") ? "bar" : effectiveType;
    var isHorizontalBar = effectiveType === "bar-horizontal";
    var isStackedBar = effectiveType === "bar-stacked";
    var isClusteredBar = effectiveType === "bar-clustered";
    var isLabeledBar = effectiveType === "bar-labeled";
    var isCleanBarVariant = isClusteredBar || isLabeledBar;
    var isDeamsSeries = isDeamsMonthlySeries(data);
    var _b = useState(0), tablePage = _b[0], setTablePage = _b[1];
    var _c = useState([]), selectedSeries = _c[0], setSelectedSeries = _c[1];
    var _d = useState(false), showAllDeamsCards = _d[0], setShowAllDeamsCards = _d[1];
    var _e = useState(false), isMunicipiosMapReady = _e[0], setIsMunicipiosMapReady = _e[1];
    var _f = useState(false), municipiosMapLoadError = _f[0], setMunicipiosMapLoadError = _f[1];
    var _g = useState(null), municipiosMapGeoJson = _g[0], setMunicipiosMapGeoJson = _g[1];
    var echartsRef = useRef(null);
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var isMultiSeries = useMemo(function () {
        return isMultiSeriesChart(displayData, baseType);
    }, [baseType, displayData]);
    useEffect(function () {
        setTablePage(0);
    }, [data]);
    useEffect(function () {
        setSelectedSeries([]);
    }, [data, effectiveType]);
    useEffect(function () {
        setShowAllDeamsCards(false);
    }, [data]);
    useEffect(function () {
        if (baseType !== "map")
            return;
        var cancelled = false;
        var ensureMunicipiosMap = function () { return __awaiter(void 0, void 0, void 0, function () {
            var geoJson, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsMunicipiosMapReady(false);
                        setMunicipiosMapLoadError(false);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, loadMunicipiosGeoJson()];
                    case 2:
                        geoJson = _a.sent();
                        if (!echarts.getMap(PIAUI_MUNICIPIOS_MAP_KEY)) {
                            echarts.registerMap(PIAUI_MUNICIPIOS_MAP_KEY, geoJson);
                        }
                        if (!cancelled) {
                            setIsMunicipiosMapReady(Boolean(echarts.getMap(PIAUI_MUNICIPIOS_MAP_KEY)));
                            setMunicipiosMapLoadError(false);
                            setMunicipiosMapGeoJson(geoJson);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        console.error("[ChartRenderer] failed to load municipios map", error_3);
                        if (!cancelled) {
                            setIsMunicipiosMapReady(false);
                            setMunicipiosMapLoadError(true);
                            setMunicipiosMapGeoJson(null);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        void ensureMunicipiosMap();
        return function () {
            cancelled = true;
        };
    }, [baseType]);
    useEffect(function () {
        var _a;
        var node = (_a = echartsRef.current) === null || _a === void 0 ? void 0 : _a.ele;
        if (!node)
            return;
        var ro = new ResizeObserver(function () {
            var _a, _b;
            (_b = (_a = echartsRef.current) === null || _a === void 0 ? void 0 : _a.getEchartsInstance()) === null || _b === void 0 ? void 0 : _b.resize();
        });
        ro.observe(node);
        return function () { return ro.disconnect(); };
    }, []);
    var customLegendItems = useMemo(function () {
        if (!(baseType === "line" || baseType === "bar"))
            return [];
        try {
            var dataset = getChartDataset(displayData);
            var multiKeys = resolveMultiSeriesKeys(displayData, dataset);
            if (multiKeys) {
                var seriesKey_1 = multiKeys.seriesKey, valueKey_1 = multiKeys.valueKey;
                var totals_1 = new Map();
                dataset.forEach(function (item) {
                    var _a;
                    var name = String(item[seriesKey_1]);
                    var value = parseNumericValue(item[valueKey_1]);
                    totals_1.set(name, ((_a = totals_1.get(name)) !== null && _a !== void 0 ? _a : 0) + value);
                });
                return Array.from(totals_1.entries()).map(function (_a, index) {
                    var name = _a[0], value = _a[1];
                    return ({
                        name: name,
                        value: value,
                        color: getChartColor(name, index),
                    });
                });
            }
            if (baseType !== "bar")
                return [];
            var _a = resolveLabelAndValueKeys(displayData, dataset), labelKey_1 = _a.labelKey, valueKey_2 = _a.valueKey;
            var formatLabel_1 = function (value) {
                var label = String(value !== null && value !== void 0 ? value : "");
                return /^\d{4}-\d{2}/.test(label) ? label.slice(0, 4) : label;
            };
            var labelValueMap_1 = new Map();
            dataset.forEach(function (item) {
                var _a, _b;
                var label = formatLabel_1(item[labelKey_1]);
                var value = parseNumericValue((_a = item[valueKey_2]) !== null && _a !== void 0 ? _a : item.value);
                labelValueMap_1.set(label, ((_b = labelValueMap_1.get(label)) !== null && _b !== void 0 ? _b : 0) + value);
            });
            return Array.from(labelValueMap_1.entries()).map(function (_a, index) {
                var name = _a[0], value = _a[1];
                return ({
                    name: name,
                    value: value,
                    color: getChartColor(name, index),
                });
            });
        }
        catch (_b) {
            return [];
        }
    }, [baseType, displayData]);
    var useCustomLegendList = !!(isMobile &&
        mobileLegendList &&
        customLegendItems.length > 0);
    var deamsLegendItems = useMemo(function () {
        if (!(isDeamsSeries && baseType === "line"))
            return [];
        try {
            var dataset_1 = getChartDataset(displayData);
            var multiKeys = resolveMultiSeriesKeys(displayData, dataset_1);
            if (!multiKeys)
                return [];
            var xKey_1 = multiKeys.xKey, seriesKey_2 = multiKeys.seriesKey, valueKey_3 = multiKeys.valueKey;
            var xValues_1 = Array.from(new Set(dataset_1.map(function (item) { return String(item[xKey_1]); })));
            return Array.from(new Set(dataset_1.map(function (item) { return String(item[seriesKey_2]); })))
                .map(function (name, index) {
                var points = xValues_1.map(function (x) {
                    var row = dataset_1.find(function (item) {
                        return String(item[xKey_1]) === x && String(item[seriesKey_2]) === name;
                    });
                    return row ? parseNumericValue(row[valueKey_3]) : null;
                });
                var value = points.reduce(function (sum, point) { return sum + (point !== null && point !== void 0 ? point : 0); }, 0);
                return {
                    name: name,
                    color: getChartColor(name, index),
                    value: value,
                    points: points,
                };
            })
                .sort(function (a, b) { return b.value - a.value || a.name.localeCompare(b.name); });
        }
        catch (_a) {
            return [];
        }
    }, [baseType, displayData, isDeamsSeries]);
    var visibleDeamsLegendItems = useMemo(function () {
        if (!isDeamsSeries)
            return [];
        if (showAllDeamsCards)
            return deamsLegendItems;
        return deamsLegendItems.slice(0, DEAMS_INITIAL_VISIBLE_CARDS);
    }, [deamsLegendItems, isDeamsSeries, showAllDeamsCards]);
    var pieLegendItems = useMemo(function () {
        if (baseType !== "pie")
            return [];
        try {
            var dataset = getChartDataset(displayData);
            var _a = resolveLabelAndValueKeys(displayData, dataset), labelKey_2 = _a.labelKey, valueKey_4 = _a.valueKey;
            return dataset.map(function (item, index) {
                var _a, _b, _c;
                return ({
                    name: String((_a = item[labelKey_2]) !== null && _a !== void 0 ? _a : "—"),
                    value: parseNumericValue((_b = item[valueKey_4]) !== null && _b !== void 0 ? _b : item.value),
                    color: getChartColor(String((_c = item[labelKey_2]) !== null && _c !== void 0 ? _c : "—"), index),
                });
            });
        }
        catch (_b) {
            return [];
        }
    }, [baseType, displayData]);
    var useCustomPieLegend = baseType === "pie" && pieLegendItems.length > 0;
    var pieLegendValueFormatter = useCallback(function (value) {
        var _a;
        var hasNumericPercentualColumn = ((_a = displayData.columns) !== null && _a !== void 0 ? _a : []).some(function (column) { return column.name === "percentual" && column.type === "numeric"; });
        return hasNumericPercentualColumn
            ? formatPercentValue(value)
            : formatNumericValue(value);
    }, [displayData.columns]);
    var handleLegendItemClick = useCallback(function (seriesName) {
        setSelectedSeries(function (current) {
            return current.includes(seriesName)
                ? current.filter(function (item) { return item !== seriesName; })
                : __spreadArray(__spreadArray([], current, true), [seriesName], false);
        });
    }, []);
    var handleDeamsLegendItemClick = useCallback(function (seriesName) {
        setSelectedSeries(function (current) {
            return current.length === 1 && current[0] === seriesName ? [] : [seriesName];
        });
    }, []);
    var handleClearLegendSelection = useCallback(function () {
        setSelectedSeries([]);
    }, []);
    var handleWebLegendSelect = useCallback(function (params) {
        if (isDeamsSeries || useCustomLegendList || !params.name)
            return;
        setSelectedSeries(function (current) {
            return current.length === 1 && current[0] === params.name
                ? []
                : [params.name];
        });
        requestAnimationFrame(function () {
            var _a, _b;
            (_b = (_a = echartsRef.current) === null || _a === void 0 ? void 0 : _a.getEchartsInstance()) === null || _b === void 0 ? void 0 : _b.dispatchAction({ type: "legendAllSelect" });
        });
    }, [isDeamsSeries, useCustomLegendList]);
    var chartEvents = useMemo(function () { return ({
        legendselectchanged: handleWebLegendSelect,
    }); }, [handleWebLegendSelect]);
    var option = useMemo(function () {
        if (baseType === "table")
            return {};
        try {
            var dataset = getChartDataset(displayData);
            if (baseType === "line" || baseType === "bar") {
                var multiKeys = resolveMultiSeriesKeys(displayData, dataset);
                if (multiKeys) {
                    return buildMultiSeriesOption(displayData, baseType, isDeamsSeries, isStackedBar, isClusteredBar, selectedSeries, useCustomLegendList, isMobile, formatPeriodoLabel, formatPeriodoTooltipLabel, buildDeamsYAxisTicks, title);
                }
            }
            if (baseType === "pie") {
                return buildPieOption(displayData, useCustomPieLegend, isMobile);
            }
            if (baseType === "heatmap") {
                return buildHeatmapOption(displayData, isMobile);
            }
            if (baseType === "map") {
                if (!isMunicipiosMapReady || !municipiosMapGeoJson)
                    return {};
                return buildMunicipiosMapOption(displayData, PIAUI_MUNICIPIOS_MAP_KEY, municipiosMapGeoJson);
            }
            if (baseType === "line") {
                return buildSimpleLineOption(displayData, isMobile);
            }
            var useSimpleBarLegendFilter = baseType === "bar" && useCustomLegendList;
            return buildSimpleBarOption(displayData, baseType, isHorizontalBar, isStackedBar, isLabeledBar, isCleanBarVariant, selectedSeries, useSimpleBarLegendFilter, isMobile);
        }
        catch (e) {
            console.error("[ChartRenderer] option build failed:", e, displayData);
            return {};
        }
    }, [
        baseType,
        displayData,
        isHorizontalBar,
        isCleanBarVariant,
        isClusteredBar,
        isLabeledBar,
        isDeamsSeries,
        isStackedBar,
        useCustomPieLegend,
        isMunicipiosMapReady,
        municipiosMapGeoJson,
        selectedSeries,
        useCustomLegendList,
        isMobile,
        title,
    ]);
    if (baseType === "table") {
        return (_jsx(TableRenderer, { data: displayData, title: title, bare: bare, tablePage: tablePage, onPageChange: setTablePage }));
    }
    if (baseType === "map" && municipiosMapLoadError) {
        return (_jsx(Box, __assign({ sx: { color: "#6B7280", py: 6, textAlign: "center" } }, { children: "N\u00E3o foi poss\u00EDvel carregar o mapa." })));
    }
    var chart = (_jsx(Box, { children: _jsxs(Box, __assign({ sx: { minWidth: 0 } }, { children: [_jsx(ReactEChartsCore, { ref: echartsRef, echarts: echarts, option: option, onEvents: chartEvents, style: {
                        height: baseType === "pie"
                            ? useCustomPieLegend
                                ? 340
                                : 460
                            : isMultiSeries && isDeamsSeries
                                ? 1067
                                : isMultiSeries
                                    ? 440
                                    : baseType === "map"
                                        ? 520
                                        : baseType === "heatmap"
                                            ? 420
                                            : baseType === "bar" && !isMultiSeries
                                                ? isHorizontalBar
                                                    ? 440
                                                    : 380
                                                : 340,
                        width: "100%",
                    }, notMerge: true, lazyUpdate: true, showLoading: loading ||
                        (baseType === "map" &&
                            !isMunicipiosMapReady &&
                            !municipiosMapLoadError), loadingOption: {
                        text: "Carregando...",
                        color: "#034EA2",
                        textColor: "#374151",
                        maskColor: "rgba(255, 255, 255, 0.8)",
                        zlevel: 0,
                        fontFamily: "Montserrat, sans-serif",
                    } }), useCustomLegendList && (_jsx(MobileLegendList, { items: customLegendItems, selectedSeries: selectedSeries, onItemClick: handleLegendItemClick, onClear: handleClearLegendSelection })), useCustomPieLegend && (_jsx(PieLegendList, { items: pieLegendItems, isMobile: isMobile, valueFormatter: pieLegendValueFormatter })), isDeamsSeries && visibleDeamsLegendItems.length > 0 && (_jsx(DeamsLegendCards, { items: visibleDeamsLegendItems, selectedSeries: selectedSeries, onItemClick: handleDeamsLegendItemClick, onClear: handleClearLegendSelection, showAll: showAllDeamsCards, onToggleShowAll: function () { return setShowAllDeamsCards(function (current) { return !current; }); }, canToggle: deamsLegendItems.length > DEAMS_INITIAL_VISIBLE_CARDS }))] })) }));
    if (bare)
        return _jsx(_Fragment, { children: chart });
    return (_jsxs(Box, __assign({ className: "chat-chart-export", sx: {
            width: "100%",
            background: "#fff",
            borderRadius: "16px",
            border: "1px solid #ECEEF4",
            p: 2,
            mt: 1,
        } }, { children: [title && (_jsx(Box, __assign({ sx: { mb: 1.5, px: 0.5 } }, { children: _jsx(Box, __assign({ component: "div", sx: {
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: 600,
                        fontSize: "0.9rem",
                        color: "#1F2937",
                    } }, { children: title })) }))), chart] })));
};
export default ChartRenderer;
